export default function LandingPage({ onSignIn }) {
  const features = [
    { title: 'Idea Vault', desc: 'Organize and protect your toy and game concepts in one secure place.' },
    { title: 'AI Pitch Builder', desc: 'Generate tailored pitch scripts and presentation materials powered by AI.' },
    { title: 'Company Matching', desc: 'Find the right manufacturers, retailers, and licensing partners for your ideas.' },
    { title: 'Trend Intelligence', desc: 'Stay ahead with AI-driven market trends and category insights.' },
    { title: 'Pitch Events', desc: 'Organize and participate in structured pitch events with built-in NDA workflows.' },
    { title: 'BOM Builder', desc: 'Estimate product costs with AI-powered Bill of Materials analysis.' },
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#F1F0FB' }}>
      {/* Nav */}
      <nav style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '16px 32px', maxWidth: 1100, margin: '0 auto',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <img src="/logo-playventr.png" alt="PlayVentr" style={{ height: 36 }} />
        </div>
        <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
          <a href="/terms" style={{ fontSize: 13, color: '#64748B', fontFamily: 'Poppins, sans-serif', textDecoration: 'none' }}>Terms</a>
          <a href="/privacy" style={{ fontSize: 13, color: '#64748B', fontFamily: 'Poppins, sans-serif', textDecoration: 'none' }}>Privacy</a>
          <button
            onClick={onSignIn}
            style={{
              padding: '8px 20px', borderRadius: 10,
              background: '#c9a84c', color: 'white',
              fontSize: 13, fontWeight: 600, fontFamily: 'Poppins, sans-serif',
              border: 'none', cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(201,168,76,0.3)',
            }}
          >
            Sign In
          </button>
        </div>
      </nav>

      {/* Hero */}
      <div style={{ textAlign: 'center', padding: '80px 16px 60px', maxWidth: 700, margin: '0 auto' }}>
        <img src="/logo-playventr.png" alt="PlayVentr" style={{ height: 64, margin: '0 auto 24px', display: 'block' }} />
        <p style={{ fontSize: 13, color: '#c9a84c', fontFamily: 'Montserrat, sans-serif', fontWeight: 600, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 20 }}>
          Pitch Smarter. License Faster.
        </p>
        <p style={{ fontSize: 17, color: '#64748B', fontFamily: 'Poppins, sans-serif', lineHeight: 1.6, maxWidth: 560, margin: '0 auto 36px' }}>
          PlayVentr is an AI-powered platform that connects toy and game inventors with toy companies. Inventors use PlayVentr to organize ideas, build pitches, and get matched with companies seeking new products. Companies use PlayVentr to define what they're looking for, discover matched inventor ideas, and run virtual pitch events.
        </p>
        <button
          onClick={onSignIn}
          style={{
            padding: '14px 36px', borderRadius: 14,
            background: 'linear-gradient(135deg, #c9a84c, #F59E0B)', color: 'white',
            fontSize: 16, fontWeight: 600, fontFamily: 'Poppins, sans-serif',
            border: 'none', cursor: 'pointer',
            boxShadow: '0 4px 20px rgba(201,168,76,0.35)',
            transition: 'all 0.15s',
          }}
          onMouseEnter={e => { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 8px 28px rgba(201,168,76,0.45)'; }}
          onMouseLeave={e => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = '0 4px 20px rgba(201,168,76,0.35)'; }}
        >
          Get Started
        </button>
      </div>

      {/* What PlayVentr Does — explicit purpose section for Google */}
      <div style={{ background: 'white', padding: '60px 16px' }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <h2 style={{ fontFamily: '"EB Garamond", Georgia, serif', fontSize: 28, fontWeight: 700, color: '#0F172A', textAlign: 'center', marginBottom: 12 }}>
            What is PlayVentr?
          </h2>
          <p style={{ fontSize: 15, color: '#64748B', fontFamily: 'Poppins, sans-serif', lineHeight: 1.7, textAlign: 'center', maxWidth: 640, margin: '0 auto 32px' }}>
            PlayVentr is a B2B platform operated by Forge & Wade LLC that uses artificial intelligence to match toy inventors with toy companies. The platform facilitates idea submissions, AI-powered pitch generation, company wish list matching, virtual pitch event scheduling, NDA management, and bill of materials estimation. PlayVentr requests access to your Gmail account solely to send event invitations and pitch-related emails on your behalf.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 20 }}>
            <div style={{ textAlign: 'center', padding: 20 }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>💡</div>
              <h3 style={{ fontFamily: 'Poppins, sans-serif', fontSize: 14, fontWeight: 600, color: '#0F172A', marginBottom: 4 }}>For Inventors</h3>
              <p style={{ fontSize: 13, color: '#64748B', fontFamily: 'Poppins, sans-serif', lineHeight: 1.5 }}>Submit toy ideas, get AI-matched with companies, and book pitch meetings at virtual events.</p>
            </div>
            <div style={{ textAlign: 'center', padding: 20 }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>🏢</div>
              <h3 style={{ fontFamily: 'Poppins, sans-serif', fontSize: 14, fontWeight: 600, color: '#0F172A', marginBottom: 4 }}>For Companies</h3>
              <p style={{ fontSize: 13, color: '#64748B', fontFamily: 'Poppins, sans-serif', lineHeight: 1.5 }}>Define your wish list, get matched inventor ideas scored by AI, and run virtual pitch events.</p>
            </div>
            <div style={{ textAlign: 'center', padding: 20 }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>🤖</div>
              <h3 style={{ fontFamily: 'Poppins, sans-serif', fontSize: 14, fontWeight: 600, color: '#0F172A', marginBottom: 4 }}>AI-Powered</h3>
              <p style={{ fontSize: 13, color: '#64748B', fontFamily: 'Poppins, sans-serif', lineHeight: 1.5 }}>AI scores every idea against company wish lists, generates pitch materials, and tracks industry trends.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Features */}
      <div style={{ maxWidth: 960, margin: '0 auto', padding: '60px 16px 80px' }}>
        <h2 style={{ fontFamily: '"EB Garamond", Georgia, serif', fontSize: 28, fontWeight: 700, color: '#0F172A', textAlign: 'center', marginBottom: 40 }}>
          Everything You Need to License Your Ideas
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 20 }}>
          {features.map(f => (
            <div key={f.title} style={{
              background: 'rgba(255,255,255,0.97)', backdropFilter: 'blur(24px)',
              border: '1px solid #E2E8F0', borderRadius: 16,
              boxShadow: '0 4px 16px rgba(0,0,0,0.05)', padding: 28,
            }}>
              <h3 style={{ fontFamily: '"EB Garamond", Georgia, serif', fontSize: 19, fontWeight: 700, color: '#0F172A', marginBottom: 8 }}>
                {f.title}
              </h3>
              <p style={{ fontSize: 14, color: '#64748B', fontFamily: 'Poppins, sans-serif', lineHeight: 1.6, margin: 0 }}>
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Pricing */}
      <div style={{ background: 'white', padding: '60px 16px' }}>
        <div style={{ maxWidth: 960, margin: '0 auto' }}>
          <h2 style={{ fontFamily: '"EB Garamond", Georgia, serif', fontSize: 28, fontWeight: 700, color: '#0F172A', textAlign: 'center', marginBottom: 12 }}>
            Simple, Transparent Pricing
          </h2>
          <p style={{ fontSize: 15, color: '#64748B', fontFamily: 'Poppins, sans-serif', lineHeight: 1.6, textAlign: 'center', maxWidth: 560, margin: '0 auto 40px' }}>
            Choose the plan that fits your needs. Upgrade or downgrade anytime.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 20, maxWidth: 880, margin: '0 auto' }}>
            {/* Inventor */}
            <div style={{
              background: 'rgba(255,255,255,0.97)', border: '1px solid #E2E8F0', borderRadius: 16,
              boxShadow: '0 4px 16px rgba(0,0,0,0.05)', padding: 28, display: 'flex', flexDirection: 'column',
            }}>
              <h3 style={{ fontFamily: '"EB Garamond", Georgia, serif', fontSize: 22, fontWeight: 700, color: '#0F172A', marginBottom: 4 }}>Inventor</h3>
              <div style={{ fontFamily: 'Poppins, sans-serif', fontSize: 32, fontWeight: 700, color: '#0F172A', marginBottom: 4 }}>$49<span style={{ fontSize: 15, fontWeight: 400, color: '#64748B' }}>/month</span></div>
              <ul style={{ listStyle: 'none', padding: 0, margin: '16px 0 24px', flex: 1 }}>
                {['1 user', '20 matches/day', 'Idea Vault', 'AI Pitch Builder', 'BOM Builder', 'Trend Intelligence'].map(f => (
                  <li key={f} style={{ fontSize: 14, color: '#334155', fontFamily: 'Poppins, sans-serif', padding: '4px 0', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ color: '#c9a84c' }}>&#10003;</span> {f}
                  </li>
                ))}
              </ul>
              <button onClick={onSignIn} style={{
                padding: '12px 24px', borderRadius: 12, width: '100%',
                background: 'transparent', color: '#0F172A', fontSize: 14, fontWeight: 600,
                fontFamily: 'Poppins, sans-serif', border: '2px solid #E2E8F0', cursor: 'pointer',
              }}>Get Started</button>
            </div>

            {/* Studio — featured */}
            <div style={{
              background: 'rgba(255,255,255,0.97)', border: '2px solid #c9a84c', borderRadius: 16,
              boxShadow: '0 4px 24px rgba(201,168,76,0.15)', padding: 28, display: 'flex', flexDirection: 'column',
              position: 'relative',
            }}>
              <div style={{
                position: 'absolute', top: -12, left: '50%', transform: 'translateX(-50%)',
                background: 'linear-gradient(135deg, #c9a84c, #F59E0B)', color: 'white',
                fontSize: 11, fontWeight: 700, fontFamily: 'Poppins, sans-serif',
                padding: '4px 14px', borderRadius: 999, letterSpacing: 0.5,
              }}>Best for studios</div>
              <h3 style={{ fontFamily: '"EB Garamond", Georgia, serif', fontSize: 22, fontWeight: 700, color: '#0F172A', marginBottom: 4, marginTop: 4 }}>Studio</h3>
              <div style={{ fontFamily: 'Poppins, sans-serif', fontSize: 32, fontWeight: 700, color: '#0F172A', marginBottom: 0 }}>$149<span style={{ fontSize: 15, fontWeight: 400, color: '#64748B' }}>/month</span></div>
              <div style={{ fontSize: 13, color: '#64748B', fontFamily: 'Poppins, sans-serif', marginBottom: 4 }}>+ $49/month per additional member</div>
              <ul style={{ listStyle: 'none', padding: 0, margin: '16px 0 24px', flex: 1 }}>
                {['First member included', '50 matches/day per user', 'Shared idea vault', 'Studio profile', 'All AI tools', 'Invite unlimited members'].map(f => (
                  <li key={f} style={{ fontSize: 14, color: '#334155', fontFamily: 'Poppins, sans-serif', padding: '4px 0', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ color: '#c9a84c' }}>&#10003;</span> {f}
                  </li>
                ))}
              </ul>
              <button onClick={onSignIn} style={{
                padding: '12px 24px', borderRadius: 12, width: '100%',
                background: 'linear-gradient(135deg, #c9a84c, #F59E0B)', color: 'white', fontSize: 14, fontWeight: 600,
                fontFamily: 'Poppins, sans-serif', border: 'none', cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(201,168,76,0.3)',
              }}>Start a Studio</button>
            </div>

            {/* Company */}
            <div style={{
              background: 'rgba(255,255,255,0.97)', border: '1px solid #E2E8F0', borderRadius: 16,
              boxShadow: '0 4px 16px rgba(0,0,0,0.05)', padding: 28, display: 'flex', flexDirection: 'column',
            }}>
              <h3 style={{ fontFamily: '"EB Garamond", Georgia, serif', fontSize: 22, fontWeight: 700, color: '#0F172A', marginBottom: 4 }}>Company</h3>
              <div style={{ fontFamily: 'Poppins, sans-serif', fontSize: 32, fontWeight: 700, color: '#0F172A', marginBottom: 4 }}>$349<span style={{ fontSize: 15, fontWeight: 400, color: '#64748B' }}>/month</span></div>
              <ul style={{ listStyle: 'none', padding: 0, margin: '16px 0 24px', flex: 1 }}>
                {['1 user', 'Unlimited matches', 'Wishlists & pipelines', 'Pitch events', 'NDA management', 'Team features'].map(f => (
                  <li key={f} style={{ fontSize: 14, color: '#334155', fontFamily: 'Poppins, sans-serif', padding: '4px 0', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ color: '#c9a84c' }}>&#10003;</span> {f}
                  </li>
                ))}
              </ul>
              <button onClick={onSignIn} style={{
                padding: '12px 24px', borderRadius: 12, width: '100%',
                background: 'transparent', color: '#0F172A', fontSize: 14, fontWeight: 600,
                fontFamily: 'Poppins, sans-serif', border: '2px solid #E2E8F0', cursor: 'pointer',
              }}>Get Started</button>
            </div>
          </div>
        </div>
      </div>

      {/* Who it's for */}
      <div style={{ background: 'rgba(255,255,255,0.6)', padding: '60px 16px' }}>
        <div style={{ maxWidth: 700, margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontFamily: '"EB Garamond", Georgia, serif', fontSize: 28, fontWeight: 700, color: '#0F172A', marginBottom: 16 }}>
            Built for Inventors & Companies
          </h2>
          <p style={{ fontSize: 15, color: '#64748B', fontFamily: 'Poppins, sans-serif', lineHeight: 1.7, marginBottom: 12 }}>
            Whether you're an independent toy inventor with a breakthrough idea or a company looking for the next big thing, PlayVentr streamlines the entire licensing workflow -- from ideation to signed deal.
          </p>
          <p style={{ fontSize: 15, color: '#64748B', fontFamily: 'Poppins, sans-serif', lineHeight: 1.7 }}>
            Companies can organize pitch events, review inventor submissions, manage NDAs, and discover new products -- all in one secure platform.
          </p>
        </div>
      </div>

      {/* Footer with prominent privacy/terms links */}
      <footer style={{ background: '#0F172A', padding: '48px 16px 32px' }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: 32, marginBottom: 32 }}>
            {/* Brand */}
            <div>
              <div style={{ marginBottom: 12 }}>
                <img src="/logo-playventr.png" alt="PlayVentr" style={{ height: 28, filter: 'brightness(0) invert(1)' }} />
              </div>
              <p style={{ fontSize: 12, color: '#94A3B8', fontFamily: 'Poppins, sans-serif', lineHeight: 1.5, maxWidth: 260 }}>
                The toy industry's AI-powered matchmaker. A product by Forge & Wade LLC.
              </p>
            </div>

            {/* Links */}
            <div>
              <h4 style={{ fontSize: 11, fontWeight: 700, color: '#94A3B8', fontFamily: 'Poppins, sans-serif', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 }}>Legal</h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <a href="/privacy" style={{ fontSize: 13, color: '#CBD5E1', fontFamily: 'Poppins, sans-serif', textDecoration: 'none' }}>Privacy Policy</a>
                <a href="/terms" style={{ fontSize: 13, color: '#CBD5E1', fontFamily: 'Poppins, sans-serif', textDecoration: 'none' }}>Terms of Service</a>
              </div>
            </div>

            {/* Contact */}
            <div>
              <h4 style={{ fontSize: 11, fontWeight: 700, color: '#94A3B8', fontFamily: 'Poppins, sans-serif', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 }}>Contact</h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <span style={{ fontSize: 13, color: '#CBD5E1', fontFamily: 'Poppins, sans-serif' }}>support@playventr.com</span>
                <span style={{ fontSize: 13, color: '#CBD5E1', fontFamily: 'Poppins, sans-serif' }}>inquiries@forgeandwade.com</span>
              </div>
            </div>
          </div>

          <div style={{ borderTop: '1px solid #1E293B', paddingTop: 20, textAlign: 'center' }}>
            <p style={{ fontSize: 11, color: '#64748B', fontFamily: 'Poppins, sans-serif' }}>
              &copy; {new Date().getFullYear()} Forge & Wade LLC. All rights reserved. |{' '}
              <a href="/privacy" style={{ color: '#94A3B8', textDecoration: 'none' }}>Privacy Policy</a> |{' '}
              <a href="/terms" style={{ color: '#94A3B8', textDecoration: 'none' }}>Terms of Service</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
